/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { later } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import BulkImportStatus from 'linced-app/enums/bulk-import-status';

export default class ImportRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  init() {
    super.init(...arguments);

    this.router.on('routeWillChange', (transition) => {
      if (
        isEmpty(transition.from) ||
        !transition.from.find((route) => route.name === this.routeName)
      ) {
        return;
      }

      this.controller.cancelTimer();
    });
  }

  model(params) {
    return this.store.findRecord('people/bulk-import', params.bulk_import_id);
  }

  async afterModel(model) {
    if (model.initiator === null && model.initiatorId) {
      // initiator reads the person from the store. A person that does not
      // load shows no name.
      await this.store.findRecord('person', model.initiatorId).catch(() => {});
    }
    if (model.status === BulkImportStatus.PROCESSING) {
      // This import isn't done - schedule a check in 2 seconds.
      later(this, () => this.controller.checkImportStatus(), 2000);
    }
  }
}
